module.exports = __webpack_public_path__ + "96ddc12bc3e7b8b6cbad2d0de023c8ea.svg";